"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  namespaced: true,
  state: {
    goodsData: [],
    pageInfo: {
      size: 7,
      total: 0,
      current: 1
    }
  },
  mutations: {
    /**
     * 设置图片
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setGoodsData: function setGoodsData(state, data) {
      state.goodsData = data;
    },
    /**
     * 设置分页
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setPageInfo: function setPageInfo(state, data) {
      state.pageInfo = data;
    }
  },
  actions: {
    /**
     * 登录
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    handleGoods: function handleGoods(_ref, _ref2) {
      var commit = _ref.commit;
      var current = _ref2.current,
        keyword = _ref2.keyword;
      keyword.tab_key = 'onsale';
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.livegoods('GET', {
          status: 2,
          limit: 7,
          page: current
        }).then(function (data) {
          var total = data.total;
          commit('setPageInfo', {
            size: 7,
            total: total,
            current: current
          });
          commit('setGoodsData', data.list);
          resolve(data.list);
        }).catch(function (error) {
          console.error('错误提示', error);
          reject();
        });
      });
    },
    /**
     * [handleGoods description]
     * @param  {[type]} options.commit [description]
     * @return {[type]}                [description]
     */
    handleSearch: function handleSearch() {
      return new Promise(function (resolve, reject) {});
    }
  }
};
exports.default = _default;